export const drink = [
  {
    id: "1",
    name: "1.5 litre Drink",
    price: "210",
  },
  {
    id: "2",
    name: "500 ml Drink",
    price: "120",
  },
  {
    id: "3",
    name: "Regular Drink",
    price: "80",
  },
  {
    id: "4",
    name: "Tin/Can",
    price: "120",
  },
  {
    id: "5",
    name: "1 Litre Drink",
    price: "160",
  },
  {
    id: "6",
    name: "2.25 Litre Drink",
    price: "260",
  },
  {
    id: "4",
    name: "Mineral Water large",
    price: "120",
  },
  {
    id: "1",
    name: "Mineral Water",
    price: "60",
  },
];
